module.exports = __webpack_public_path__ + "static/media/coin.65314f4a.svg";